<template>
  <div class="experian-login-logo">
    <img src="@/assets/img/logo-experian.svg" />
  </div>
</template>

<script setup lang="ts">
</script>

<style></style>
